import { mainAxios } from "@/mainAxios";
import { getAgenteAccessToken } from "@/services/tokens.service";

const getAuthConfig = () => ({
    headers: {
        Authorization: "Bearer " + getAgenteAccessToken(),
    },
});

// Obtener datos del reporte (tabla paginada)
export const getSolicitudesPostventaReport = async (body) => {
    const config = getAuthConfig();

    const serverResponse = await mainAxios.post(
        "/v1/reportes/solicitudes-postventa",
        body,
        config
    );

    return serverResponse.data;
};

// Descargar archivo CSV
export const downloadSolicitudesPostventaFile = async (body) => {
    const config = getAuthConfig();

    const serverResponse = await mainAxios.post(
        "/v1/reportes/solicitudes-postventa/file",
        body,
        config
    );

    return serverResponse.data;
};
